module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    ref: "logo",
    staticClass: "layer bg-accent layer-logo"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    ref: "dark",
    staticClass: "layer bg-light"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading_container"
  }, [_c('img', {
    attrs: {
      "src": "/images/logo-w.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b99f189a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/Loader.vue
// module id = 659
// module chunks = 0